
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import ForWhom from './components/ForWhom';
import Journey from './components/Journey';
import Relationship from './components/Relationship';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Purchase from './components/Purchase';
import Footer from './components/Footer';
import CookieConsent from '../../components/feature/CookieConsent';

export default function HomePage() {
  const [openPolicyId, setOpenPolicyId] = useState<string | null>(null);

  /** 
   * Handles clicks on privacy / cookies policy links.
   * Dispatches a custom event that the Footer component (or any listener) can react to.
   * Includes a safety check for environments where `window` may be undefined (e.g., SSR).
   */
  const handlePolicyClick = (policyType: 'privacy' | 'cookies') => {
    if (typeof window === 'undefined') {
      // In non‑browser environments we simply log the action.
      console.warn('Attempted to dispatch policy event in a non‑browser environment');
      return;
    }

    try {
      const event = new CustomEvent('openPolicy', { detail: { policyType } });
      window.dispatchEvent(event);
    } catch (err) {
      console.error('Failed to dispatch openPolicy event:', err);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <ForWhom />
      <Journey />
      <Relationship />
      <Testimonials />
      <FAQ />
      <Purchase />
      <Footer />
      <CookieConsent language="lt" onPolicyClick={handlePolicyClick} />
    </div>
  );
}
